import React from "react";
import { Platform, StyleSheet, Text, View } from "react-native";
import { Body, Button, Container, Content, Left, Right, Switch, Title } from "native-base";
import { Slider } from "antd";
import Header from "../../components/ui/WrappedHeader";
import Icon from "react-native-vector-icons/Ionicons";
import { connect } from "react-redux";
//import Slider from '@react-native-community/slider';
import ScreenLoadingIndicator from "../../components/ui/ScreenLoadingIndicator";

import { Actions, ActionTypes, INITIAL_STATE, reducer } from "../../redux/screens/course/RecordSettingRedux";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import { NavigationService } from "../../navigation";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";
import UIDs from "../../UIDs";
import styles from "../StyleHelper";
import { withTranslation } from "react-i18next";
import _ from "lodash";

const uid = UIDs.screens.course.recordsetting;
const isIos = Platform.OS === "ios";

export function levelOfRecordSetting(config) {
    if (!config) {
        return 0;
    }

    if (config.continuousPlay) {
        if (config.showPinYin) {
            return 5;
        }
        return 6;
    }

    var enableCount = 0;
    if (config.showPinYin) {
        enableCount += 1;
    }
    if (config.showTranslate) {
        enableCount += 1;
    }
    if (config.playExample) {
        enableCount += 1;
    }
    if (enableCount >= 3) {
        return 1;
    }
    if (enableCount >= 2) {
        return 2;
    }
    if (enableCount >= 1) {
        return 3;
    }
    return 4;
}

class RecordSettingScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: this._handleLoadScreenViewAsyncDone },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);
        this.state = {
            recordSetting: _.clone(props.localState.recordSetting),
        };
        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        this.props.loadScreenViewAsync(this.props.recordSetting);
    }

    _handleLoadScreenViewAsyncDone = () => {
        this.setState({ recordSetting: _.clone(this.props.localState.recordSetting) });
    };

    _handleClose = changed => {
        if (changed) {
            this.props.saveRecordSetting(this.state.recordSetting, r => {
                if (this.props.onClose) {
                    this.props.onClose(changed, r ? this.props.t("difficultySettingChanged") : null, this.state.recordSetting);
                } else {
                    NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
                }
            });
        } else {
            if (this.props.onClose) {
                this.props.onClose(false);
            } else {
                NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
            }
        }
    };

    renderScreen() {
        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) {
            return <ScreenLoadingIndicator title={this.props.t("difficultySetting")} />;
        }

        const audioSpeed = (this.state.recordSetting.audioSpeed || 0);
        return (
            <View style={this.props.style || { flex: 1 }}>
                <Container>
                    <Header style={[styles.headerColor]}>
                        <Left style={[styles.flex1]}>
                            <Button
                                transparent
                                onPress={() => {
                                    this._handleClose(false);
                                }}>
                                <Icon name="ios-arrow-back" style={{ fontSize: 30, color: "#777" }} />
                            </Button>
                        </Left>
                        <Body style={[styles.flex3, styles.alignItemsCenter]}>
                            <Title style={[styles.headerTitle]}>{this.props.t("difficultySetting")}</Title>
                        </Body>
                        <Right style={[styles.flex1]}>
                            <Button
                                transparent
                                onPress={() => {
                                    const oldSetting = this.props.localState.recordSetting;
                                    const newSetting = this.state.recordSetting;
                                    const equal =
                                        !!newSetting.showPinYin == !!oldSetting.showPinYin &&
                                        !!newSetting.showTranslate == !!oldSetting.showTranslate &&
                                        !!newSetting.playExample == !!oldSetting.playExample &&
                                        !!newSetting.continuousPlay == !!oldSetting.continuousPlay &&
                                        (newSetting.audioSpeed == oldSetting.audioSpeed);
                                    this._handleClose(!equal);
                                }}>
                                <Text style={{ fontSize: 16, color: "#157efb" }}>{this.props.t("save")}</Text>
                            </Button>
                        </Right>
                    </Header>
                    <Content style={{ backgroundColor: "#f7f7f7" }}>
                        <View
                            style={{
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                paddingTop: 35,
                                paddingBottom: 35,
                                backgroundColor: "#fff",
                                borderBottomWidth: 1,
                                borderBottomColor: "#f7f7f7",
                            }}>
                            <Text style={{ color: "#e55f5b", fontSize: 32 }}>{levelOfRecordSetting(this.state.recordSetting)}</Text>
                            <Text style={{ color: "#8a8a8a", fontSize: 14, marginTop: 12 }}>{this.props.t("currentDifficultyLevel")}</Text>
                        </View>
                        <View style={localStyles.row}>
                            <Text style={localStyles.label}>{this.props.t("showPinYin")}</Text>
                            <View style={{ flex: 1 }} />
                            <Switch
                                value={!!this.state.recordSetting.showPinYin}
                                disabled={this.props.language !== 'zh'}
                                onValueChange={v => {
                                    this.setState({ recordSetting: { ...this.state.recordSetting, showPinYin: v ? 1 : 0 } });
                                }}
                            />
                        </View>
                        <View style={localStyles.row}>
                            <Text style={localStyles.label}>{this.props.t("showTranslate")}</Text>
                            <View style={{ flex: 1 }} />
                            <Switch
                                value={!!this.state.recordSetting.showTranslate}
                                onValueChange={v => {
                                    var newSetting = { ...this.state.recordSetting, showTranslate: v ? 1 : 0 };
                                    if (v) {
                                        newSetting.continuousPlay = 0;
                                    }
                                    this.setState({ recordSetting: newSetting });
                                }}
                            />
                        </View>
                        <View style={localStyles.row}>
                            <Text style={localStyles.label}>{this.props.t("playExample")}</Text>
                            <View style={{ flex: 1 }} />
                            <Switch
                                value={!!this.state.recordSetting.playExample}
                                onValueChange={v => {
                                    var newSetting = { ...this.state.recordSetting, playExample: v ? 1 : 0 };
                                    if (v) {
                                        newSetting.continuousPlay = 0;
                                    }
                                    this.setState({ recordSetting: newSetting });
                                }}
                            />
                        </View>
                        <View style={localStyles.row}>
                            <Text style={localStyles.label}>{this.props.t("continuousPlay")}</Text>
                            <View style={{ flex: 1 }} />
                            <Switch
                                value={!!this.state.recordSetting.continuousPlay}
                                onValueChange={v => {
                                    var newSetting = { ...this.state.recordSetting, continuousPlay: v ? 1 : 0 };
                                    if (v) {
                                        newSetting.showTranslate = 0;
                                        newSetting.playExample = 0;
                                    }
                                    this.setState({ recordSetting: newSetting });
                                }}
                            />
                        </View>
                        <View style={localStyles.titleRow}>
                            <Text style={localStyles.titleLabel}>{this.props.t('speedSetting')}</Text>
                        </View>
                        <View style={localStyles.bigRow}>
                            <Text style={localStyles.speedLabel}>{this.props.t('slow')}</Text>
                            <View style={{flex: 1, marginLeft: 4, marginRight: 4, flexDirection: 'column'}}>
                                <View style={{flexDirection: 'row', alignItems: 'center',
                                              paddingLeft: (isIos ? 4 : 4),
                                              paddingRight: (isIos ? 4 : 4),
                                              justifyContent: 'space-between'}}>
                                    <View style={localStyles.numBox}>
                                        {audioSpeed === -2 ? (<Text style={localStyles.numText}>-2</Text>) : null}
                                    </View>
                                    <View style={localStyles.numBox}>
                                        {audioSpeed === -1 ? (<Text style={localStyles.numText}>-1</Text>) : null}
                                    </View>
                                    <View style={localStyles.numBox}>
                                        {audioSpeed === 0 ? (<Text style={localStyles.numText}>0</Text>) : null}
                                    </View>
                                    <View style={localStyles.numBox}>
                                        {audioSpeed === 1 ? (<Text style={localStyles.numText}>1</Text>) : null}
                                    </View>
                                    <View style={localStyles.numBox}>
                                        {audioSpeed === 2 ? (<Text style={localStyles.numText}>2</Text>) : null}
                                    </View>
                                </View>
                                <Slider min={-2} max={2} value={audioSpeed} tooltipVisible={false}
                                        onChange={(v) => {
                                            var newSetting = {...this.state.recordSetting, audioSpeed: v};
                                            this.setState({recordSetting: newSetting});
                                        }}
                                        onAfterChange={(v) => {
                                            var newSetting = {...this.state.recordSetting, audioSpeed: v};
                                            this.setState({recordSetting: newSetting});
                                        }}/>
                                {/*
                                <Slider
                                    style={{marginTop: 0, marginLeft: (isIos ? 2 : 0), marginRight: (isIos ? 2 : 0)}}
                                    //maximumTrackTintColor={"#5c94f2"}
                                    //minimumTrackTintColor={"#5c94f2"}
                                    //thumbTintColor={"#fff"}
                                    //thumbImage={require("../../components/ui/images/audioPlayer/icon_control_slider1.png")}
                                    //trackImage={require("./images/audioPlayer/icon_control_slider1.png")}
                                    value={audioSpeed}
                                    step={1}
                                    tapToSeek={true}
                                    minimumValue={-2}
                                    maximumValue={2}
                                    onValueChange={(v) => {
                                        var newSetting = {...this.state.recordSetting, audioSpeed: v};
                                        this.setState({recordSetting: newSetting});
                                    }}
                                    onSlidingComplete = {(v) => {
                                        var newSetting = {...this.state.recordSetting, audioSpeed: v};
                                        this.setState({recordSetting: newSetting});
                                    }}
                                />
                                */}
                            </View>
                            <Text style={localStyles.speedLabel}>{this.props.t('fast')}</Text>
                        </View>
                    </Content>
                </Container>
            </View>
        );
    }
}

const localStyles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: "#fff",
        height: 45,
        borderTopWidth: 1,
        borderTopColor: "#f7f7f7",
        paddingLeft: 16,
        paddingRight: 16,
    },
    label: {
        color: "#333",
    },
    titleRow: {
        flexDirection: 'row',
        alignItems: "center",
        backgroundColor: '#f7f7f7',
        borderTopWidth: 1,
        borderTopColor: '#f7f7f7',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
    },
    titleLabel: {
        color: '#888',
    },
    speedLabel: {
        marginTop: 12,
    },
    bigRow: {
        flexDirection: 'row',
        alignItems: "center",
        backgroundColor: '#fff',
        height: 64,
        borderTopWidth: 1,
        borderTopColor: '#f7f7f7',
        paddingLeft: 16,
        paddingRight: 16,
    },
    numBox: {
        width: 24,
        alignItems: 'center',
        justifyContent: 'center',
    },
    numText: {
        color: '#5c94f2',
    },
});

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (vo) => dispatch(Actions.loadScreenViewAsync(vo)),
        saveRecordSetting: (v, cb) => dispatch(Actions.saveRecordSettingAsync(v, cb)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(RecordSettingScreen));
